import type { WaterPhaseVolumeFactorCalculator } from "../d";

import { waterPhaseVolumeFactorBwCalculator } from "./waterPhaseVolumeFactorBwCalculator";
import { waterSolutionGasRswCalculator } from "./waterSolutionGasRswCalculator";
import { waterDensityPwCalculator } from "./waterDensityPwCalculator";

export const waterPhaseVolumeFactorCalculator: WaterPhaseVolumeFactorCalculator =
  {
    waterSolutionGasRswCalculator,
    waterDensityPwCalculator,
    waterPhaseVolumeFactorBwCalculator
  };
